import { ClassType } from '../core';

export function tryRegisterExtensionMethod<Base, T, K extends keyof Base>(target: Base, functionName: K, fn: Base[K]) {
  if (!target[functionName]) {
    target[functionName] = fn;

    if (target === Object.prototype) {
      Object.defineProperty(Object.prototype, functionName, {
        value: fn,
        configurable: true,
        enumerable: false,
        writable: true,
      });
    } else {
      target[functionName] = fn;
    }
  } else {
    // console.error(`failed to register extension method '${String(functionName)}'`);
  }
}

export function Extension<T, K extends keyof T>(classType: ClassType<T>, functionName: K) {
  return function (
    target: any,
    propertyName: string,
    // eslint-disable-next-line @typescript-eslint/ban-types
    descriptor: PropertyDescriptor
  ) {
    tryRegisterExtensionMethod(classType.prototype, functionName, function (...args: any[]) {
      // @ts-ignore
      return descriptor?.value?.(this, ...args);
    });
  };
}
